import * as React from "react";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import "./Footer.css";

function Footer(props: ITranslationProps) {
    return (
        <footer className="footer fixed-bottom">
            <div className="container">
                <a href="http://www.cgi.com/housing" target="_blank">© {new Date().getFullYear()} CGI Federal Inc.</a>
                <span className="footer-divider">|</span>
                <a href="http://www.cgi.com/web/en/global_privacy.htm" target="_blank">{props.t("Footer.PrivacyPolicy")}</a>
                <span className="footer-divider">|</span>
                <a href="http://www.cgi.com/web/en/legal_restrictions.htm" target="_blank">{props.t("Footer.TermsOfUse")}</a>
            </div>
        </footer>
    );
}

export default translateComponent(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.tsx